import React from 'react';
import { connect } from 'react-redux';
import { IAppState } from '../../../../state/reducers';
import { selectTotalClipsDuration } from '../../../../state/selectedClipsPreview';
import { secondsToString } from '../../../VirtualClipper/utils/timeStringFormat';
import { selectIsAnySelected } from '../../../VirtualClipper/state/clipList';
import { DialogHeaderDuration } from '../../styles/dialog';
import {
  IProps,
  IStateProps,
} from './interfaces';

const SelectedClipsTotalDuration: React.FunctionComponent<IProps> = (props: IProps) => {
  const { isClipsSelected, totalClipsDuration } = props;

  if (!isClipsSelected) {
    return null;
  }

  return (
    <DialogHeaderDuration>
      {`Duration: ${secondsToString(totalClipsDuration)}`}
    </DialogHeaderDuration>
  );
};

const mapStateToProps = (state: IAppState): IStateProps => ({
  isClipsSelected: selectIsAnySelected(state),
  totalClipsDuration: selectTotalClipsDuration(state),
});

export default connect(
  mapStateToProps,
)(SelectedClipsTotalDuration);
